module.exports = __webpack_public_path__ + "list_icon2.png?aca0ae9f66e7fa32f6a4a4de258a74e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list_icon2.png
// module id = 14
// module chunks = 0